import { Observable } from 'rxjs';
import { mapTo, tap } from 'rxjs/operators';

import { catchErrorLogRet } from '../../../common/rest.operators';
import { epicDependencies } from '../../../store';
import {
    ViewGoalCommitment,
    WinningPercentageService,
} from '../../insight/winning-percentage/core';
import { currentMainState } from '../game-plan.state';

export function loadGoalCommitments(userId: number): Observable<void> {
    const wpService = epicDependencies.injector.get<WinningPercentageService>(
        WinningPercentageService,
    );

    const state = currentMainState();

    return wpService.listGoaCommitments(userId).pipe(
        tap((ret: ViewGoalCommitment[]) => {
            const eligible = ret.filter((e) => e.data.eligible === true);
            eligible.forEach((gc) => {
                if (gc.data == null) {
                    return;
                }
                gc.data.goalStartDate =
                    gc.data.goalStartDate == null
                        ? null
                        : new Date(gc.data.goalStartDate);
            });

            state.goalCommitments = eligible;
        }),
        catchErrorLogRet(null),
        mapTo(null),
    );
}
